import React from "react";
import trans from "../../translations.json"
import { Modal } from "antd";
import "../../ds/styles/components/buttons/buttons.css"

export const SelectionLimitReached = (props) => (
  <div className="modal">
    <Modal
      wrapClassName="compare-chart--modal"
      title={props.title ? props.title : trans.phu.compareModalTitle[props.lang]}
      visible={props.visible}
      onOk={props.onOk}
      onCancel={props.onCancel}
      cancelText="Unselect All"
      footer={[
        <button className="ontario-button ontario-button--secondary" onClick={() => props.onCancel()}>
          Unselect all
        </button>,
        <button className="ontario-button ontario-button--primary" onClick={() => props.onOk()}>
          Ok
        </button>,
      ]}
    >
      <p>
        {props.text ? props.text : trans.phu.compareModalText[props.lang]}
      </p>
    </Modal>
  </div>
);
